import {
  LIST_LOYALTY_TIERS_REQUEST,
  RESET_LOYALTY_TIER_QUERY
} from './constants';

export const listLoyaltyTiers = () => ({
  type: LIST_LOYALTY_TIERS_REQUEST
});

export const resetLoyaltyTierQuery = () => ({
  type: RESET_LOYALTY_TIER_QUERY
});
